import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  scheduledDate: string;
  formatDate: (date: string) => string;
}

const AssessmentScheduledDateLabelField: React.FC<Props> = ({
  scheduledDate,
  formatDate,
}) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.assessment.expectedText,
        label: formatDate(scheduledDate),
      }}
    />
  );
};

export default React.memo(AssessmentScheduledDateLabelField);
